export const COOKIES_NAME_CONFIG = {
  ACCESS_TOKEN: "em_access_token",
  REFRESH_TOKEN: "em_refresh_token",
  USER_DATA: "em_user_data",
  TENANT_CONTEXT: "em_tenant_context",
  SESSION_ID: "em_session_id",
  XSRF_TOKEN: "em_xsrf_token",
  /** Middleware's 30s session-validity cache (proxy.ts) — set with `path: "/"`. */
  SESSION_OK: "session_ok",
};
